import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "home" */'@/views/Home.vue'),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import(/* webpackPrefetch: true */  '@/views/Test.vue')
  },
  {
    path: '/vanidea',
    name: 'Vanidea',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "utils-pages" */ '@/views/Vanidea.vue'),
  },
  {
    path: '/insurance',
    name: 'Insurance',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "utils-pages" */ '@/views/Insurance.vue'),
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "utils-pages" */ '@/views/Contact.vue'),
  },

  {
    path: '/about',
    name: 'AboutUs',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "utils-pages" */ '@/views/AboutUs.vue')
  },

  {
    path: '/terms',
    name: 'Terms&Conditions',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "documents" */ '@/views/docs/Terms.vue')
  },
  
  {
    path: '/disclaimer',
    name: 'Disclaimer',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "documents" */ '@/views/docs/Disclaimer.vue')
  },

  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "documents" */ '@/views/docs/PrivacyPolicy.vue')
  },
  {
    path: '/categories/:category',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Categories" */ '@/views/categories/Categories.vue')
  },
  {
    path: '/:state-custom-vanity-license-plate',
    redirect: (to) => {
      return to.params.state
    }
  },
  {
    path: '/categories/:category/:state',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "Categories" */ '@/views/categories/Categories.vue')
  },
  {
    path: '/:state/:text',
    name: 'DetailPlate',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "detail-plate" */ '@/views/DetailPlate.vue'),
  },
  {
    path: '/:state',
    component: () => import(/* webpackPrefetch: true */ /* webpackChunkName: "custom-vanity" */ '@/views/CustomVanityAd.vue'),
    beforeEnter: (to, from, next) => {
      if (store.state.states.includes(to.fullPath.split('/')[1])) {
        next()
      } else {
        next('/state/not/exist')
      }
    }
  },
  {
    path: "/:catchAll(.*)",
    // redirect: '/404'
    component: () => import(/* webpackPrefetch: true */ '@/views/other/NotFound.vue')
  },
]

const router = createRouter({
  mode: 'history',
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
  base: process.env.BASE_URL
})

router.beforeEach((to, from, next) => {
  if (to.path.slice(-1) === '/' && to.path.length > 1) {
    next(to.path.slice(0, -1))
  } else {
    next()
  }

})

export default router